export { default } from './useLocale';
